import { OrderType } from '../../types/order'
import { markRaw } from 'vue'
import { PriceUtils } from '../../utils/price'

export const state = () => ({
    items: [],
    discountType: 'fixed',
    discountValue: 0,
    availableTaxTypes: [],
    subtotal: 0,
    total: 0,
    // Removed old taxRate property
    loading: false,
    error: null,
    notes: "",
    selectedTables: [],
    holdInvoiceId: null,
    holdOrderDescription: null,
    type: null, // Add type to state
    editingInvoiceId: null, // Track which invoice is being edited
    editingInvoiceNumber: null, // Track invoice number being edited
    editingInvoiceStatus: null // Track invoice status being edited
})

export const mutations = {
    setNotes(state, notes) {
        if (notes === state.notes) return
        state.notes = markRaw(notes)
    },

    setSelectedTables(state, tables) {
        state.selectedTables = tables
    },

    setHoldInvoiceId(state, id) {
        state.holdInvoiceId = id
        if (!id) {
            state.holdOrderDescription = null
        }
    },

    setHoldOrderDescription(state, description) {
        state.holdOrderDescription = description
    },

    updateTotals(state) {
        state.subtotal = state.items.reduce((sum, item) => {
          const itemPrice = PriceUtils.normalizePrice(item.price);
          return sum + itemPrice * item.quantity;
        }, 0);
      
        state.discountAmount = state.discountType === "%" ?
          (state.subtotal * state.discountValue) / 100 :
          state.discountValue;
      
        state.total = Math.max(0, state.subtotal - state.discountAmount);
      
        console.log('After updateTotals:', JSON.parse(JSON.stringify(state)));
    },

    setDiscount(state, { type, value }) {

        if (!type || !['fixed', '%'].includes(type)) {
            console.warn('⚠️ Tipo de descuento inválido:', type);
            return;
        }

        const parsedValue = Number(value);
        if (isNaN(parsedValue) || parsedValue < 0) {
            console.warn('⚠️ Valor de descuento inválido:', value);
            return;
        }

        state.discountType = type;
        state.discountValue = parsedValue;

        console.log('Calling updateTotals...');
        mutations.updateTotals(state);
    },
      
    setItems(state, items) {
        state.items = items;
        mutations.updateTotals(state);
    },

    setType(state, type) {
        if (type && !Object.values(OrderType).includes(type)) {
            throw new Error(`Invalid order type: ${type}`)
        }
        state.type = type
    },

    clearCart(state) {
        state.items = []
        state.discountType = 'fixed'
        state.discountValue = 0
        state.notes = ''
        state.selectedTables = []
        state.holdInvoiceId = null
        state.holdOrderDescription = null
        state.type = null // Reset type when clearing cart
        state.editingInvoiceId = null // Reset editing invoice ID
    }
}